import { render, staticRenderFns } from "./NFTs.vue?vue&type=template&id=74fd5631&scoped=true&"
import script from "./NFTs.vue?vue&type=script&lang=js&"
export * from "./NFTs.vue?vue&type=script&lang=js&"
import style0 from "./NFTs.vue?vue&type=style&index=0&id=74fd5631&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fd5631",
  null
  
)

export default component.exports